import { render, staticRenderFns } from "./NicheAreaAdd.vue?vue&type=template&id=ceaac340&scoped=true"
import script from "./NicheAreaAdd.vue?vue&type=script&lang=js"
export * from "./NicheAreaAdd.vue?vue&type=script&lang=js"
import style0 from "./NicheAreaAdd.vue?vue&type=style&index=0&id=ceaac340&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceaac340",
  null
  
)

export default component.exports